import { TooltipProps, TooltipContentProps } from '@procore/core-react/dist/_typedoc/Tooltip/Tooltip.types.json';
import * as React from 'react';
export default {
  TooltipProps,
  TooltipContentProps,
  React
};